import { useEffect, useState } from 'react';
import { getContestClasses, getContestLeaderboard } from '../../utils/api';
import { useLocalStorage } from '../../utils/use-local-storage';
import { useAuth0 } from "@auth0/auth0-react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import Container from '@mui/material/Container';
import Loading from '../loading';

interface ContestClass {
  id: number;
  clazz: string;
}

interface LeaderboardEntry {
  ranking: number;
  name: string;
  points: number;
  me: boolean;
}

const Leaderboard = () => {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [clazzes, setClazzes] = useState<ContestClass[]>([]);
  const [data, setData] = useState<LeaderboardEntry[] | null>(null);
  const [clazzId, setClazzId] = useLocalStorage("clazzId", 0);

  useEffect(() => {
      if (isAuthenticated) {
        getAccessTokenSilently().then((token) => setAccessToken(token));
      }
    }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    if (!isLoading) {
      getContestClasses().then((res) => {
        setClazzes(res);
        if (clazzId == 0 || !res.some((d: ContestClass) => d.id === clazzId)) {
          setClazzId(res[0].id);
        }
      })
    }
  }, [isLoading]);

  useEffect(() => {
    if (clazzId > 0 && clazzes.length > 0) {
      getContestLeaderboard(accessToken, clazzId).then((res) => {
        setData(res);
      });
    }
  }, [clazzes, clazzId]);

  if (isLoading || clazzes.length === 0 || data === null) {
    return <Loading />;
  }

  let leaderboard;
  if (data && data.length > 0) {
    leaderboard = (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Ranking</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Points</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map(x => (
            <TableRow 
              key={x.name}
              sx={{
                border: x.me ? '2px solid' : 'none',
                borderColor: x.me ? 'primary.main' : 'transparent',
              }}
            >
              <TableCell>#{x.ranking}</TableCell>
              <TableCell>{x.name}</TableCell>
              <TableCell>{x.points}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  else {
    leaderboard = <i>No data</i>;
  }
  
  return (
    <>
      {clazzes.length > 1 &&
        <Container sx={{ display: "flex", justifyContent: "center" }}>
          <ToggleButtonGroup color="primary" size="small" exclusive>
            {clazzes.map(({id, clazz}) => (
              <ToggleButton key={id} value={id} selected={clazzId === id} onClick={() => {
                setClazzId(id);
              }}>
                {clazz}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Container>
      }
      {leaderboard}
    </>
  )
}

export default Leaderboard;